import { Component, OnInit } from '@angular/core';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { ImageService } from 'src/app/services/image.service';
import { MatDatepickerInputEvent } from '@angular/material';
import { GiftCardClientsModel, GiftCardModel, GiftCardContactModel, GiftCardTypesModel } from 'src/app/models/gifcardVirtual.model';
import { Observable } from 'rxjs';
import { ImageTemplate } from 'src/app/models/image.model';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { map, startWith } from 'rxjs/operators';
import { TraceService } from 'src/app/services/trace.service';
import { FileService } from 'src/app/services/file.service';
import { GifcardFisicaService } from 'src/app/services/giftcardFisica.service';

@Component({
    selector: 'app-ordersales-fisica-step1',
    templateUrl: './ordersales-fisica-step1.component.html',
    styleUrls: ['./ordersales-fisica-step1.component.css']
})
export class OrderSalesFisicaStep1Component implements OnInit {

    id_order_sales: string;
    id_modelo_gift_card: string;
    id_cliente: string;
    id_contacto: string;
    id_template: number;
    id_type_ncr: number;
    nombre_modelo_gift_card: string;
    email_contacto: string;
    begin_number: number;
    minDate = new Date();
    maxDate = new Date();
    userCurrent: string;
    loading: boolean = false;
    selectClient: GiftCardClientsModel;
    datasourceSelectClient: GiftCardClientsModel[] = [];
    filteredClients: Observable<GiftCardClientsModel[]>;
    fileOrder = new FormControl(null, [FileUploadValidators.filesLimit(1), Validators.required]);
    fileCotizacion = new FormControl(null, [FileUploadValidators.filesLimit(1), Validators.required]);
    fileAdicional1 = new FormControl(null, [FileUploadValidators.filesLimit(1)]);
    fileAdicional2 = new FormControl(null, [FileUploadValidators.filesLimit(1)]);
    fileAdicional3 = new FormControl(null, [FileUploadValidators.filesLimit(1)]);

    orderSalesFormGroup: FormGroup;
    datasourceSelectContact: GiftCardContactModel[] = [];
    datasourceSelectTypes: GiftCardTypesModel[] = [];
    datasourceSelectTypesTemp: GiftCardTypesModel[] = [];
    datasourceSelectModels: GiftCardModel[] = [];
    datasourceSelectTemplate: ImageTemplate[] = [];

    disabledButtonSave: boolean = false;

    constructor(private giftCardFiscaService: GifcardFisicaService,
        private giftCardService: GifcardVirtualService,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        private authService: AuthService,
        private traceService: TraceService,
        private fileService: FileService) { }

    ngOnInit() {
        this.userCurrent = this.authService.getCurrentUser();
        //this.dateAdapter.setLocale("es");        
        this.populateSelectModels();
        this.createOrderSalesForm();
        this.populateSelectClient();
        this.filteredClients =
            this.orderSalesFormGroup.get('selClientGiftCard').valueChanges.pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value.NRORUC_CLIENTE),
                map(value => value ? this.filterRUC(value) : this.datasourceSelectClient.slice())
            );
    }

    filterRUC(value: string): GiftCardClientsModel[] {
        const filterValue = value.toLowerCase();
        return this.datasourceSelectClient.filter(client => client.NRORUC_CLIENTE.toLowerCase().indexOf(filterValue) === 0);
    }

    displayFn(client?: GiftCardClientsModel): string | undefined {
        return client ? client.NRORUC_CLIENTE : undefined;
    }

    createOrderSalesForm() {
        this.orderSalesFormGroup = this.formBuilder.group({
            selModeloGiftCard: ['', Validators.required],
            selClientGiftCard: ['', Validators.required],
            selContactGiftCard: ['', Validators.required],
            txtNroRUCComprador: new FormControl({ value: '', disabled: true }, Validators.required),
            txtRazSocComprador: new FormControl({ value: '', disabled: true }, Validators.required),
            txtCorreoComprador: new FormControl({ value: '', disabled: true }, Validators.required),
            txtContacComprador: new FormControl({ value: '', disabled: true }, Validators.required),
            txtNroOrdenCompra: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]+([\-][a-zA-Z0-9]+)?')]],
            imgOrdenCompra: this.fileOrder,
            imgCotizacion: this.fileCotizacion,
            imgAdicional1: this.fileAdicional1,
            imgAdicional2: this.fileAdicional2,
            imgAdicional3: this.fileAdicional3,
            txtImpOrdenCompra: ['', [Validators.required, Validators.pattern('[0-9]+([\.,][0-9]+)?')]],
            txtCanOrdenCompra: ['', [Validators.required, Validators.pattern('[0-9]*')]],
            txtObservaciones: ['']
        });
    }

    saveOrderSales() {
        debugger;
        if (this.orderSalesFormGroup.valid) {

            this.loading = true;

            if (Number(this.orderSalesFormGroup.get('txtImpOrdenCompra').value) <= 0) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese un monto válido.' });
                this.loading = false;
            }
            else if (Number(this.orderSalesFormGroup.get('txtCanOrdenCompra').value) <= 0) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese una cantidad válida.' });
                this.loading = false;
            }
            else if (!this.fileOrder.value) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo orden de compra.' });
                this.loading = false;
            }
            else if (!this.fileOrder.valid) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen de la orden de compra' });
                this.loading = false;
            }
            else if (!this.fileCotizacion.value) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo cotización.' });
                this.loading = false;
            }
            else if (!this.fileCotizacion.valid) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen de la cotización' });
                this.loading = false;
            }
            else if (!this.fileAdicional1.valid) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen o pdf para el archivo adicional 1' });
                this.loading = false;
            }
            else if (!this.fileAdicional2.valid) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen o pdf para el archivo adicional 2' });
                this.loading = false;
            }
            else if (!this.fileAdicional3.valid) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen o pdf para el archivo adicional 3' });
                this.loading = false;
            }
            else if ((this.fileAdicional1.value || this.fileAdicional2.value || this.fileAdicional3.value) && !this.observaciones.value) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe registrar el motivo por que se adjunta un o más documentos adicionales.' });
                this.loading = false;
            }
            else {
                let orderSales = {
                    "p_id_modelo_gift_card": this.id_modelo_gift_card,
                    "p_id_cliente_gift_card": this.id_cliente,
                    "p_id_contact_gift_card": this.id_contacto,
                    "p_nro_orden_compra": this.nro_orden_compra2.value,
                    "p_imp_orden_compra": this.importe_orden_compra2.value,
                    "p_can_orden_compra": this.cantidad_orden_compra2.value,
                    "p_observaciones": this.observaciones.value,
                    "p_creationuser": this.userCurrent
                };

                this.giftCardFiscaService.CreateOrderSalesFisica(orderSales).subscribe(
                    (response) => {
                        let json = response;
                        this.id_order_sales = json.NEW_ID_ORDER_SALES;
                        this.updateImageOrder();
                        this.disabledButtonSave = true;
                        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'La orden de compra se registro correctamente.' });
                    },
                    (error) => {
                        console.log(error);
                        this.loading = false;
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al registrar la orden de compra.' });
                    }
                )
            }
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese todos los campos obligatorios.' });
        }
    }

    updateImageOrder() {
        let params = new FormData();
        params.append('p_id_order_gift_card', this.id_order_sales);
        params.append('p_type_order_sales', "F");
        params.append('p_type_file', this.fileService.FILE_ORDER);
        params.append('p_creationuser', this.userCurrent);
        params.append('file', this.fileOrder.value[0]);        
        this.fileService.CreateGiftCardOrderSalesFisicaFile(params).subscribe(
            (response) => {
                this.updateImageCotizacion();
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo de la orden de compra cargada correctamente.' });
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la imagen de la orden de compra.' });
            }
        )
    }

    updateImageCotizacion() {
        let params = new FormData();
        params.append('p_id_order_gift_card', this.id_order_sales);
        params.append('p_type_order_sales', this.giftCardFiscaService.TYPE_ORDER_SALES_FISICA);
        params.append('p_type_file', this.fileService.FILE_COTIZ);
        params.append('p_creationuser', this.userCurrent);
        params.append('file', this.fileCotizacion.value[0]);
        this.fileService.CreateGiftCardOrderSalesFisicaFile(params).subscribe(
            (response) => {
                if (this.fileAdicional1.value) {
                    this.updateImageAdicional1();
                }
                if (this.fileAdicional2.value) {
                    this.updateImageAdicional2();
                }
                if (this.fileAdicional3.value) {
                    this.updateImageAdicional3();
                }
                this.createOrderSalesTrace();
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo de la cotización cargada correctamente.' });
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la imagen de la cotización.' });
            }
        )
    }

    updateImageAdicional1() {
        let params = new FormData();
        params.append('p_id_order_gift_card', this.id_order_sales);
        params.append('p_type_order_sales', this.giftCardFiscaService.TYPE_ORDER_SALES_FISICA);
        params.append('p_type_file', this.fileService.FILE_ADIC1);
        params.append('p_creationuser', this.userCurrent);
        params.append('file', this.fileAdicional1.value[0]);
        this.fileService.CreateGiftCardOrderSalesFisicaFile(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo adicional 1 cargado correctamente.' });
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el archivo adicional 1.' });
            }
        )
    }

    updateImageAdicional2() {
        let params = new FormData();
        params.append('p_id_order_gift_card', this.id_order_sales);
        params.append('p_type_order_sales', this.giftCardFiscaService.TYPE_ORDER_SALES_FISICA);
        params.append('p_type_file', this.fileService.FILE_ADIC2);
        params.append('p_creationuser', this.userCurrent);
        params.append('file', this.fileAdicional2.value[0]);
        this.fileService.CreateGiftCardOrderSalesFisicaFile(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo adicional 2 cargado correctamente.' });
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el archivo adicional 2.' });
            }
        )
    }

    updateImageAdicional3() {
        let params = new FormData();
        params.append('p_id_order_gift_card', this.id_order_sales);
        params.append('p_type_order_sales', this.giftCardFiscaService.TYPE_ORDER_SALES_FISICA);
        params.append('p_type_file', this.fileService.FILE_ADIC3);
        params.append('p_creationuser', this.userCurrent);
        params.append('file', this.fileAdicional3.value[0]);
        this.fileService.CreateGiftCardOrderSalesFisicaFile(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo adicional 3 cargado correctamente.' });
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el archivo adicional 3.' });
            }
        )
    }

    populateSelectClient() {
        this.giftCardService.GetGiftCardClients().subscribe(
            (response: GiftCardClientsModel[]) => {
                this.datasourceSelectClient = response;
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar clientes.' });
            }
        )
    }

    populateSelectContact() {
        let client = {
            "p_id_cliente_gift_card": this.id_cliente
        };
        this.giftCardService.GetContactByClient(client).subscribe(
            (response: GiftCardContactModel[]) => {
                this.datasourceSelectContact = response;
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar contactos.' });
            }
        )
    }

    populateSelectModels() {
        let params = {
            "p_type_model" : 'V'
        }
        this.giftCardService.GetGiftCardModelsByType(params).subscribe(
            (response: GiftCardModel[]) => {
                this.datasourceSelectModels = response;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar tipos locales de gift card.' });
            }
        )
    }    

    onChangeDateIni(type: string, event: MatDatepickerInputEvent<Date>) {
        this.maxDate = event.value;
    }

    createOrderSalesTrace() {
        let params = {
            "p_id_order_gift_card": this.id_order_sales,
            "p_type_order_sales": this.giftCardFiscaService.TYPE_ORDER_SALES_FISICA,
            "p_action": 'CREADO',
            "p_observation": this.observaciones.value ? this.observaciones.value : 'Creado Correctamente.',
            "p_creationuser": this.userCurrent
        };
        this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
            (response) => {
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
            }
        )
    }

    onSelectClient(client) {
        if (client) {
            this.id_cliente = client.ID_CLIENTE.toString();
            this.orderSalesFormGroup.get('txtNroRUCComprador').setValue(client.NRORUC_CLIENTE);
            this.orderSalesFormGroup.get('txtRazSocComprador').setValue(client.RAZSOC_CLIENTE);
            this.populateSelectContact();
        }
    }

    onSelectContact() {
        this.id_contacto = this.orderSalesFormGroup.get('selContactGiftCard').value;
        for (let i = 0; i < this.datasourceSelectContact.length; i++) {
            if (this.datasourceSelectContact[i].ID_CONTACT == Number(this.id_contacto)) {
                this.orderSalesFormGroup.get('txtContacComprador').setValue(this.datasourceSelectContact[i].NOMBRE_CONTACTO);
                this.orderSalesFormGroup.get('txtCorreoComprador').setValue(this.datasourceSelectContact[i].CORREO_CONTACTO);
                this.email_contacto = this.datasourceSelectContact[i].CORREO_CONTACTO;
                break;
            }
        }
    }

    onSelectTypes(event) {
        let model = event.value;
        this.id_modelo_gift_card = model.ID_TYPES;
        this.id_type_ncr = model.ID_TYPES_NCR;
        this.nombre_modelo_gift_card = model.DESC_TYPES;
    }

    onSelectTemplate(event) {
        let template = event.value;
        if (template) {
            this.id_template = template.ID_TEMPLATE;
        }
    }

    get modelo_gif2() {
        return this.orderSalesFormGroup.get('selModeloGiftCard');
    }

    get cliente_gif2() {
        return this.orderSalesFormGroup.get('selClientGiftCard');
    }

    get contact_gif2() {
        return this.orderSalesFormGroup.get('selContactGiftCard');
    }

    get ruc_comprador2() {
        return this.orderSalesFormGroup.get('txtNroRUCComprador');
    }

    get razon_comprador2() {
        return this.orderSalesFormGroup.get('txtRazSocComprador');
    }

    get correo_comprador2() {
        return this.orderSalesFormGroup.get('txtCorreoComprador');
    }

    get contacto_comprador2() {
        return this.orderSalesFormGroup.get('txtContacComprador');
    }

    get nro_orden_compra2() {
        return this.orderSalesFormGroup.get('txtNroOrdenCompra');
    }

    get importe_orden_compra2() {
        return this.orderSalesFormGroup.get('txtImpOrdenCompra');
    }

    get cantidad_orden_compra2() {
        return this.orderSalesFormGroup.get('txtCanOrdenCompra');
    }

    get observaciones() {
        return this.orderSalesFormGroup.get('txtObservaciones');
    }

    get imgOrder() {
        return this.orderSalesFormGroup.get('imgOrdenCompra');
    }

    get imgCotizacion() {
        return this.orderSalesFormGroup.get('imgCotizacion');
    }

    get imgAdicional1() {
        return this.orderSalesFormGroup.get('imgAdicional1');
    }

    get imgAdicional2() {
        return this.orderSalesFormGroup.get('imgAdicional2');
    }

    get imgAdicional3() {
        return this.orderSalesFormGroup.get('imgAdicional3');
    }
}